import styles from './MainFormTemplate.module.css'
import React, {forwardRef, ReactNode, useEffect, useImperativeHandle, useRef} from "react";
import WaitLoader from "../../WaitLoader/WaitLoader";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {IRefInputItemLight} from "../InputItemLight/InputItemLight";
import ErrorLineItem, {ErrorLineItemRef} from "../ErrorLineItem/ErrorLineItem";

interface MainFormTemplatePropsInt
{
    children: ReactNode| undefined
    maxWidth?:string
    title?: string
    background?:string
    onClose?:()=>void
    load?:boolean
    refClone?:ErrorLineItemRef|null
//    state?:(e:string, isError:boolean)=>void
}

export interface IRefMainFormTemplate {
    state: (text:string, isError:boolean, time:number) => void;
}


const MainFormTemplate = forwardRef<IRefMainFormTemplate,MainFormTemplatePropsInt>(({refClone,load,children,maxWidth,title,background,onClose}:MainFormTemplatePropsInt, ref)=>{

    const [ldrProjectList,rsProjectList,exProjectList] = useApiQuery("/project/list","post", useRef(null));
    const refState = useRef<ErrorLineItemRef>(null)

    useImperativeHandle(ref, () => ({
        state : showState,
    }));


    useEffect(()=>{
//        if(refState.current)refState.current.show("Задача выполнена",true,0)

    },[rsProjectList])


    const showState = (text: string , isError:boolean , time:number) =>{
        if(refState.current)refState.current.show(text,isError,time)
        if(refClone) refClone?.show(text,isError,time)
    }

    const showBar = () =>{
        return (
            <div className={styles.barCont}>
                <div className={styles.stateBar} >
                    <ErrorLineItem ref={refState} ></ErrorLineItem>
                </div>
                {load &&
                    <div className={styles.loader}>
                        <WaitLoader loading={true} onlyLoading={true} api={rsProjectList}>

                        </WaitLoader>
                    </div>
                }
                {onClose &&
                    <div   onClick={()=>onClose()} className={styles.xClose}>Закрыть</div>
                }


            </div>

        )
    }
    return(
        <div className={styles.frCont} style={{maxWidth: maxWidth ? maxWidth: "100%", background: background ? background : "white"}}>
            {showBar()}

            <form>
                <div className={"row"}>
                    <div className={"col-12 my-1"}>
                        <div>{title}</div>

                    </div>
                </div>
                {children}
            </form>
        </div>
    )


} )




export default MainFormTemplate